import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicPumpingLemma = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Pumping Lemma & Closure Properties of Regular Languages"
      videos={[
        "https://www.youtube.com/embed/UoFrOT7T7ns", // Closure Properties
        "https://www.youtube.com/embed/BKIUSHYpq_Y", // Pumping Lemma
      ]}
      takeaways={[
        { text: "Application-based questions from this topic, especially Pumping Lemma." },
        { text: "Learn the proof of the closure properties of regular languages." },
        { text: "For Pumping Lemma problems, take an example of a non-regular language and prove it." },
      ]}
      questions={[
        {text:"Prove that the following language is not regular: L = {a^(n^2) | n≥1} U {a^n b^n | n ≤ 10^(10^5)}."},
        {text:"Are the following languages regular? Justify your answer:\n L = {wxw^R | w,x ∈ (0+1)+} \n L = {xww^Ry | x,y,w ∈ (0+1)+}"},
        {text:"Show that L = {a^n b a b^(n+1)} is not regular."},
        {text:"The concatenation of two regular languages is regular. Justify why L = {a^n b^n} is not regular despite L1 = {a^n} and L2 = {b^n} being regular."},
        {text:"Prove that the regular set is not closed under infinite intersection."},
        {text:"Prove that L = {w ∈ {a,b} | w has more a’s than b’s} is not regular."},
        {text:"Use Pumping Lemma to determine whether L = {a^i b^(j^2) | i,j ≥ 1} is regular."},
        {text:"Solve for derivatives of a language:\n 1) What is L_aa for L = {a^(n+1)b^n | n ≥1}?\n 2) What is L_b for L = {a^(n+1)b^n | n ≥1}?\n 3) Prove that if L is regular, L_x is also regular."},
        {text:"Check if L1 = {a^p b^q a^r | pq,r ≥1 and p+q ≠ r} is regular."},
        {text:"Prove that regular languages are closed under perfect shuffle."},
        {text:"Use Pumping Lemma to prove L = {w ∈ {0,1}* | w contains more 0’s than 1’s} is not regular."},
        {text:"Use Pumping Lemma to prove L = {w ∈ {0,1}* | w = w^R} is not regular."},
        {text:"Prove that if A is accepted by an NFA and B is not accepted by a DFA, their concatenation is closed under regular languages."},
      ]}
      exampleVideos={[
        "https://www.youtube.com/embed/aw6Akr6_e5k", // Prime Number Set Not Regular
        "https://www.youtube.com/embed/ccdsYbgQUHY", // Square Numbers Not Regular
        "https://www.youtube.com/embed/uyI_QFuroC8", // Balanced Parentheses Not Regular
      ]}
    />
  );
}

export { ModuleSubtopicPumpingLemma };
